<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div
        class="d-flex justify-content-center align-items-center"
        style="gap: 10px"
      >
        <div>
          <div class="section-title">{{ $tc("movie", 2) }}</div>
        </div>

        <div>
          <b-form-input
            @input="onSearch"
            id="searchinputele"
            v-model="searchValue"
            placeholder="Search..."
            ref="searchinputele"
            @click="closeVtour"
          ></b-form-input>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <b-dropdown
          :text="movie_status_display"
          variant="dropdown-curve"
          class="mr-3 movie-dropdown"
        >
          <b-dropdown-item @click="onSwitchActive('Active')"
            >Active</b-dropdown-item
          >
          <b-dropdown-item @click="onSwitchActive('Draft')"
            >Draft</b-dropdown-item
          >
          <b-dropdown-item @click="onSwitchActive('Inactive')"
            >Inactive</b-dropdown-item
          >
          <b-dropdown-item @click="onSwitchActive('All')">All</b-dropdown-item>
        </b-dropdown>
        <div>
          <b-button
            v-if="
              cinema_manager_add_edit_disabled != 3 && $can('create', 'Movies')
            "
            variant="default"
            to="/cinema-manager/add-movies"
            class="btn-blue v-step-1"
            >{{ $tc("add") }}</b-button
          >
        </div>

        <div class="d-flex mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
          <b-button variant="default" @click="onFetch()" class="btn-blue">{{
            $t("fetch")
          }}</b-button>
        </div>

        <div
          v-if="movies.length > 0"
          class="d-flex justify-content-end align-items-center"
        >
          <div>{{ $t("download") }} as :</div>
          <a
            :href="BASE_URL + `${this.reportUrl}${this.movie_status}`"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table id="movie_tabel"></table>
    <div :class="movies.length > 0 ? 'w-100' : ''">
      <div class="table-scroll">
        <table class="list-view-table movie-list-table mb-2" v-if="listView">
          <thead>
            <tr>
              <th class="text-center status_table_stat">
                <span class="">{{ $tc("STAT", 2) }}</span>
              </th>
              <th class="font-blue">
                <img
                  v-if="this.columnName != 'movie_unique_identifier'"
                  @click="onSortValue('movie_unique_identifier', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('movie_unique_identifier', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('movie_unique_identifier', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />{{ $tc("movieID") }}
              </th>
              <th class="font-weight-bold">
                <img
                  v-if="this.columnName != 'movie_title'"
                  @click="onSortValue('movie_title', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('movie_title', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('movie_title', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ $tc("title") }}
              </th>
              <th
                v-for="(region, regionIndex) in distinctReleaseDates"
                :key="regionIndex"
              >
                <img
                  v-if="isSort && isAscending"
                  @click="onSortValue('mrrdr_release_date', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('mrrdr_release_date', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ region.region_name }}
              </th>
              <th>{{ $tc("distributor") }}</th>
              <th>{{ $tc("genre") }}</th>
              <th>
                <div class="grid-inner">
                  <div>CLA</div>
                  <div>PRIV</div>
                  <div>CON</div>
                  <div>CRW</div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody v-if="movies.length > 0">
            <tr
              v-for="(movie, movieIndex) in movies"
              :key="movieIndex"
              class="light_grey_back"
            >
              <td class="text-center" v-if="movies.length > 0">
                <div class="d-flex align-items-center justify-content-center">
                  <!-- <div
                    class="d-flex justify-content-center align-items-center pr-2"
                  > -->
                  <StatusDot
                    :status="
                      movie.movie_is_active === 'Y'
                        ? 'active'
                        : movie.movie_is_draft === 'Y'
                        ? 'draft'
                        : movie.movie_is_active === 'N' && 'inactive'
                    "
                  />
                </div>
              </td>

              <td class="font-blue">
                <div class="d-flex align-items-center">
                  <div
                    class="icon-eye blue-icon btn"
                    v-b-tooltip="'View'"
                    tabindex="0"
                    @click="goToRoute('/cinema-manager/view-movies', movie)"
                  ></div>
                  <div
                    v-if="$can('update', 'Movies')"
                    class="edit-pen blue-icon mx-2 btn"
                    v-b-tooltip="'Edit'"
                    tabindex="0"
                    @click="goToRoute('/cinema-manager/edit-movies', movie)"
                  ></div>
                  <span>
                    {{ movie.movie_unique_identifier }}
                  </span>
                </div>
              </td>
              <td class="">
                {{ movie.movie_title }}
                {{
                  movie.original_release_year
                    ? `(${movie.original_release_year})`
                    : ""
                }}
              </td>
              <td
                v-for="(releaseDate, releaseDateIndex) in movie.releaseDates"
                :key="releaseDateIndex"
              >
                {{ releaseDate.mrrdr_release_date || "-" }}
              </td>
              <td>{{ movie.original_distributor_name || "" }}</td>
              <td>
                {{
                  movie.genres && movie.genres.length > 0
                    ? movie.genres
                        .map((x) => x.genre_abbr || x.g_name || "")
                        .toString()
                    : ""
                }}
              </td>
              <td>
                <div class="grid-inner">
                  <StatusDot
                    :status="
                      movie.is_classic_show === 'Y'
                        ? 'active'
                        : movie.is_classic_show === 'N' && 'inactive'
                    "
                  />
                  <StatusDot
                    :status="
                      movie.is_private_show === 'Y'
                        ? 'active'
                        : movie.is_private_show === 'N' && 'inactive'
                    "
                  />
                  <StatusDot
                    :status="
                      movie.is_confirmed_show === 'Y'
                        ? 'active'
                        : movie.is_confirmed_show === 'N' && 'inactive'
                    "
                  />
                  <StatusDot
                    :status="
                      movie.is_crowd_show === 'Y'
                        ? 'active'
                        : movie.is_crowd_show === 'N' && 'inactive'
                    "
                  />
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-if="movies.length == 0">
            <tr>
              <td :colspan="5 + distinctReleaseDates.length">
                <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-pagination
      v-if="rows > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
      class="pt-3"
    ></b-pagination>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(movieGrid, movieGridIndex) in MoviesList"
        :key="movieGridIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ movieGrid.movie_title }}</h6>
            <div>
              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'Movies')"
                  to="edit-movies"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item to="view-movies">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="text">
                {{ movieGrid.lang_name }}&nbsp;-&nbsp;{{ movieGrid.mf_name }}
              </div>
            </div>
            <div class="d-flex align-items-end">
              <div class="col-4">
                <b-form-checkbox
                  disabled
                  v-model="movieGrid.movie_is_active"
                  unchecked-value="N"
                  value="Y"
                  name="check-button2"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="movies.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import MovieService from "@/services/MovieService";
import { EventBus } from "@/main";

import { groupBy } from "lodash";
import { mapGetters } from "vuex";
import StatusDot from "@/components/Partials/StatusDot.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import _ from "lodash";

export default {
  components: {
    StatusDot,
    NoRecords,
  },
  data() {
    return {
      reportUrl: "/api/admin/getmoviesReport?movie_status=",
      cinema_manager_add_edit_disabled: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      movie_is_active: "Y",
      //for search
      debounce: null,
      searchValue: "",
      focusActive: true,
      searchKey:
        "movie_title,movie_unique_identifier,alternate_movie_name_language,g_name,d_company_name,mcc_cast_name", //the key name in your table

      gridView: false,
      listView: true,
      selectedNew: "",
      MoviesList: [],
      viewingnumbers: [],
      movies: [],
      genre: [],
      releaseDates: [],
      region_id: null,

      MoviesCopy: [],
      searchCinema: "",

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "desc",
      columnName: "created_at",
      movie_status: "active",
      movie_status_display: "Active",
      releaseDateCount: 0,
      distinctReleaseDates: [],
    };
  },
  computed: {
    ...mapGetters(["getHeaderSearch"]),
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },
  watch: {
    "$route.query": {
      handler(newVal, oldVal) {
        console.log({ newVal: { ...newVal }, oldVal: { ...oldVal } });
        const currentPageFromUrl = parseInt(newVal.currentPage) || 1;
        const currentSearchFromUrl = newVal.searchValue;
        const currentmovie_statusFromUrl = newVal.movie_status;
        const currentperPageFromUrl = newVal.perPage;

        this.$nextTick(() => {
          if (!!currentPageFromUrl) {
            this.currentPage = currentPageFromUrl;
          }
          if (!!currentmovie_statusFromUrl) {
            this.movie_status = currentmovie_statusFromUrl;
          }
          if (!!currentSearchFromUrl) {
            this.searchValue = currentSearchFromUrl;
          }
          if (!!currentperPageFromUrl) {
            this.perPage = currentperPageFromUrl;
          }

          if (!_.isEqual(newVal, oldVal)) {
            this.getMovies();
          }
        });
      },
      immediate: true,
    },
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    this.getviewingnumber();
  },
  mounted() {
    EventBus.$on("changeInStatusSearch", () => {
      this.focusActive = !this.focusActive;
    });
    this.onKeyUphandler();
    window.addEventListener("keyup", this.onKeyUphandler);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.onKeyUphandler);
  },
  methods: {
    onFetch: function () {
      this.getMovies();
    },
    closeVtour() {
      let close = false;
      if (!close) {
        close = true;
      }
    },
    onSwitchActive: function (option) {
      this.$router
        .push({
          query: {
            ...this.$route.query,
            movie_status: !!option ? option.toLowerCase() : undefined,
            currentPage: "1",
            perPage: "10",
          },
        })
        .catch(() => {})
        .finally(() => {
          this.movie_status_display = option;
          this.movie_status = option.toLowerCase();
        });
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.movies = this.MoviesCopy.filter((x) => {
          if (
            x.movie_title
              .toLowerCase()
              .includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.movies = this.MoviesCopy;
      }
    },
    //Sort
    onKeyUphandler: function (event) {
      console.log(event);
      if (
        !(
          document.activeElement === document.getElementById("searchinputele")
        ) &&
        event &&
        event.key &&
        event.key.length === 1 &&
        !this.getHeaderSearch &&
        this.focusActive == true
      ) {
        this.$refs.searchinputele.focus();
        this.searchValue += event.key;
      }
    },
    onSortValue(columnName, orderby, region_id = null) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.region_id = region_id;
      this.getMovies();
    },
    getMovies() {
      if (!!this.$route.query.currentPage) {
        this.currentPage = this.$route.query.currentPage;
      }
      if (!!this.$route.query.movie_status) {
        this.movie_status = this.$route.query.movie_status;
      }
      if (!!this.$route.query.searchValue) {
        this.searchValue = this.$route.query.searchValue;
      }
      if (!!this.$route.query.perPage) {
        this.perPage = this.$route.query.perPage;
      }

      let loader = this.$loading.show();
      MovieService.GetMovies2({
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        searchKey: this.searchKey,
        columnName: this.columnName,
        orderBy: this.orderby,
        status: this.movie_status,
        region_id: this.region_id,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.movies = data.Records;
            this.MoviesCopy = data.Records;
            this.distinctReleaseDates = data.distinctReleaseDates;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue = this.perPage;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.movies = [];
            this.MoviesCopy = [];
            this.rows = 0;
            this.selectedvalue = this.perPage;
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        })
        .finally((_) => {
          setTimeout(() => loader.hide(), 0);
          this.$forceUpdate();
        });
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      let q = { ...this.$route.query };
      let perPagevalue = this.rows;
      if (event !== "All") {
        perPagevalue = event;
      }

      this.$router
        .push({
          query: { ...q, perPage: !!perPagevalue ? perPagevalue : undefined },
        })
        .catch(() => {})
        .finally(() => {
          if (event == "All") {
            this.perPage = this.rows;
            this.selectedvalue = event;
            // this.onChangePagination();
          } else {
            console.log("Numbers :", event);
            this.selectedvalue = event;
            this.perPage = event;
            console.log("perPage :", this.perPage);
            //this.onChangePagination();
          }
        });
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      this.$router
        .push({
          query: { ...this.$route.query, currentPage: !!event ? event : 1 },
        })
        .catch(() => {})
        .finally(() => {
          if (event === undefined || event === null) {
            this.currentPage = 1;
          } else {
            this.currentPage = event;
          }
          // this.getMovies();
        });
    },

    //search
    onSearch(event) {
      let q = {
        ...this.$route.query,
        searchValue: !!event ? event : undefined,
        currentPage: "1",
        perPage: "10",
      };

      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.$router
          .push({
            query: q,
          })
          .catch(() => {})
          .finally(() => {
            this.searchValue = event;
            this.perPage = 10;
            this.currentPage = 1;
          });
      }, 800);
    },
    goToRoute: function (path, movie) {
      this.$router.push({
        path: path,
        query: {
          movie_id: movie.movie_id,
        },
      });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>
<style>
.hiddenimg {
  display: none;
  position: absolute;
  z-index: 1000;
  top: 0;
  right: 0;
}
.hiddenImageWrap:hover .hiddenimg {
  display: block;
}
.hiddenImageWrap {
  position: relative;
}

.table-scroll .list-view-table {
  table-layout: auto;
  white-space: nowrap;
}

.table-scroll .list-view-table th {
  padding: 10px 10px;
  font-weight: bold;
}
.movie-dropdown button {
  width: 106px;
}

.table-grid-90 {
  display: grid;
  grid-template-columns: 90% 10%;
}
.table-grid-94 {
  display: grid;
  grid-template-columns: 94% 6%;
}

.grid-inner {
  display: grid;
  grid-template-columns: auto auto auto auto;
  grid-gap: 3px;
  justify-content: space-evenly;
}

.red-sq {
  background: #f9ddcd;
  height: 15px;
  width: 15px;
  border: 1px solid red;
  border-radius: 50%;
}
.green-sq {
  background: #ddfdc7;
  height: 15px;
  width: 15px;
  border: 1px solid green;
  border-radius: 50%;
}
.grey-sq {
  background: #e4e4e4;
  height: 15px;
  width: 15px;
  border: 1px solid grey;
  border-radius: 50%;
}

.blue-sq {
  background: #4682bc;
  height: 15px;
  width: 15px;
  border: 1px solid blue;
  border-radius: 50%;
}

.font-blue {
  color: #4682bc;
  font-weight: bold;
}

.status-table th:last-child,
.status-table td:last-child {
  padding-right: 0px;
}

.status-table .status_table_stat {
  padding: 10px !important;
}

.blue-icon {
  cursor: pointer;
  padding: 0;
}
.movie-list-table td {
  padding: 4px 10px !important;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MoviesComponents/movies.vue